import angular from 'angular'

import { SaleVersioningManagerService as SaleVersioningManager } from './sale-versioning-manager.service'

angular
  .module('webregister.components')
  .service('saleVersioningManager', SaleVersioningManager)
